var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 49,
    viewBox: "0 0 38 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.07288 0H23.8133L38 13.8586V45.9375C38 47.6295 36.6234 49 34.9271 49H3.07288C1.37659 49 0 47.6295 0 45.9375V3.06247C0 1.3705 1.37675 0 3.07288 0Z",
    fill: "#36C48B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 22.7677L24.8267 12.3738L37.4933 13.3637L38 13.8586V22.7677Z",
    fill: "#409573"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0001 13.8586L26.8633 13.3636C25.1797 13.3636 23.8135 12.0303 23.8135 10.3874V0L38.0001 13.8586Z",
    fill: "#81DFBA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5857 22.7825C9.98609 22.7825 9.5 23.2677 9.5 23.8663V40.6663C9.5 41.2649 9.98609 41.7502 10.5857 41.7502H27.4143C28.0139 41.7502 28.5 41.2649 28.5 40.6663V23.8663C28.5 23.2677 28.0139 22.7825 27.4143 22.7825H10.5857ZM11.6714 25.4921H17.6429V28.2018H11.6714V25.4921ZM11.6714 30.9115H17.6429V33.6212H11.6714V30.9115ZM17.6429 36.3309H11.6714V39.0405H17.6429V36.3309ZM20.3571 25.4921H26.3286V28.2018H20.3571V25.4921ZM26.3286 30.9115H20.3571V33.6212H26.3286V30.9115ZM20.3571 36.3309H26.3286V39.0405H20.3571V36.3309Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.f9b671b3.svg";
export { ForwardRef as ReactComponent };